import { apiClient } from "@/lib/api-client";

export const putValidatorDetail = async (payload: {
  year: string | number;
  semester: string | number;
  is_validator: boolean;
  niu: string;
  month: string;
  role: string;
}) => {
  const baseUrl = import.meta.env.VITE_API_BASE_URL;

  const params = new URLSearchParams({
    year: payload.year.toString(),
    semester: payload.semester.toString(),
    is_validator: payload.is_validator.toString(),
    niu: payload.niu,
    month: payload.month,
    role: payload.role,
  });

  const data = await apiClient<any>(
    `${baseUrl}/api/v1/dosen-remun/validate?${params.toString()}`,
    {
      method: "PUT",
    },
  );
  return data;
};
